export default "__VITE_ASSET__NgSqLy6R__"